import type { CSSProperties } from "react";

// ── Stitch design tokens (Material palette) ────────────────────────────────
// Mirrors the cart redesign mock so the participant forms match it.
export const STITCH = {
  primary: "#24389c",
  primaryContainer: "#3f51b5",
  primaryFixed: "#dee0ff",
  primaryFixedDim: "#bac3ff",
  onPrimary: "#ffffff",
  onSurface: "#191c1e",
  onSurfaceVariant: "#454652",
  outline: "#757684",
  outlineVariant: "#c5c5d4",
  surface: "#f7f9fc",
  surfaceBright: "#f7f9fc",
  surfaceLowest: "#ffffff",
  surfaceContainerLow: "#f2f4f7",
  surfaceContainer: "#eceef1",
  surfaceContainerHigh: "#e6e8eb",
  error: "#ba1a1a",
  secondary: "#b6171e",
  secondaryContainer: "#da3433",
  tertiary: "#004e11",
  tertiaryContainer: "#00691b",
  font: "'Plus Jakarta Sans', sans-serif",
};

export const customSelectStyle = {
  control: (provided: any, state: any) => ({
    ...provided,
    minHeight: "42px",
    borderRadius: "6px",
    fontFamily: STITCH.font,
    fontSize: "14px",
    backgroundColor: STITCH.surfaceLowest,
    border: `1px solid ${state.isFocused ? STITCH.primary : STITCH.outlineVariant}`,
    borderColor: state.isFocused ? STITCH.primary : STITCH.outlineVariant,
    boxShadow: state.isFocused ? `0 0 0 1px ${STITCH.primary}` : "none",
    "&:hover": {
      borderColor: STITCH.primary,
    },
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: STITCH.outline,
    fontSize: "14px",
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: STITCH.onSurface,
    fontSize: "14px",
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: "8px",
    fontFamily: STITCH.font,
    boxShadow: "0 8px 30px rgba(22,24,45,.12)",
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontSize: "14px",
    backgroundColor: state.isSelected
      ? STITCH.primary
      : state.isFocused
        ? STITCH.surfaceContainerLow
        : STITCH.surfaceLowest,
    color: state.isSelected ? STITCH.onPrimary : STITCH.onSurface,
    cursor: state.isDisabled ? "default" : "pointer",
  }),
};

// ── Shared form styling ───────────────────────────────────────────────────
// Reused by the participant detail forms (individual-form / group-form /
// private-events-form) so they match the redesigned cart mock. Visual only.

export const formCardStyle: CSSProperties = {
  border: `1px solid ${STITCH.outlineVariant}`,
  background: STITCH.surfaceLowest,
  padding: "1rem 1.25rem",
  borderRadius: "12px",
  marginBottom: "16px",
  fontFamily: STITCH.font,
  boxShadow: "0 1px 2px rgba(25, 28, 30, 0.06)",
};

export const formSectionHeaderStyle: CSSProperties = {
  fontSize: "13px",
  fontWeight: 600,
  color: STITCH.onSurface,
  fontFamily: STITCH.font,
  marginBottom: "1rem",
};

export const formLabelStyle: CSSProperties = {
  fontWeight: 500,
  fontSize: "12px",
  marginBottom: "0.35rem",
  color: STITCH.onSurface,
  fontFamily: STITCH.font,
};

export const formInputStyle: CSSProperties = {
  height: "42px",
  borderRadius: "6px",
  border: `1px solid ${STITCH.outlineVariant}`,
  paddingLeft: "12px",
  fontFamily: STITCH.font,
  fontSize: "14px",
  color: STITCH.onSurface,
};
